module.exports = {
  isEdgeToEdge: () => true,
  controlEdgeToEdgeValues: () => {}
};
